import React from 'react';
import cn from 'classnames';

export function Col(
  props: Pick<JSX.IntrinsicElements['div'], 'children' | 'className'>,
): React.ReactElement {
  const { children, className } = props;
  return (
    <div className={cn('odin-flex odin-flex-col odin-gap-y-9', className)}>
      {children}
    </div>
  );
}
